"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var selectors_1 = require("./selectors");
var Section_1 = require("../../utils/Section");
var constants_1 = require("./constants");
exports.fetchContent = (_a = Section_1.getActions(constants_1.namespace, selectors_1.rail), _a.fetchContent), exports.fetchRailById = _a.fetchRailById;
//# sourceMappingURL=actions.js.map